var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 15.1666C4.04671 15.1666 0.833374 11.9533 0.833374 7.99992C0.833374 4.04659 4.04671 0.833252 8.00004 0.833252C11.9534 0.833252 15.1667 4.04659 15.1667 7.99992C15.1667 11.9533 11.9534 15.1666 8.00004 15.1666ZM8.00004 1.83325C4.60004 1.83325 1.83337 4.59992 1.83337 7.99992C1.83337 11.3999 4.60004 14.1666 8.00004 14.1666C11.4 14.1666 14.1667 11.3999 14.1667 7.99992C14.1667 4.59992 11.4 1.83325 8.00004 1.83325Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.16659C7.72667 9.16659 7.5 8.93992 7.5 8.66659V5.33325C7.5 5.05992 7.72667 4.83325 8 4.83325C8.27333 4.83325 8.5 5.05992 8.5 5.33325V8.66659C8.5 8.93992 8.27333 9.16659 8 9.16659Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 11.3334C7.91337 11.3334 7.82671 11.3134 7.74671 11.2801C7.66671 11.2468 7.59337 11.2001 7.52671 11.1401C7.46671 11.0734 7.42004 11.0068 7.38671 10.9201C7.35337 10.8401 7.33337 10.7534 7.33337 10.6668C7.33337 10.5801 7.35337 10.4934 7.38671 10.4134C7.42004 10.3334 7.46671 10.2601 7.52671 10.1934C7.59337 10.1334 7.66671 10.0868 7.74671 10.0534C7.90671 9.98675 8.09337 9.98675 8.25337 10.0534C8.33337 10.0868 8.40671 10.1334 8.47337 10.1934C8.53337 10.2601 8.58004 10.3334 8.61337 10.4134C8.64671 10.4934 8.66671 10.5801 8.66671 10.6668C8.66671 10.7534 8.64671 10.8401 8.61337 10.9201C8.58004 11.0068 8.53337 11.0734 8.47337 11.1401C8.40671 11.2001 8.33337 11.2468 8.25337 11.2801C8.17337 11.3134 8.08671 11.3334 8.00004 11.3334Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8df2c39df7d8a855a3fd7350a193a74d.svg";
export { ForwardRef as ReactComponent };